"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SwipableArea = /*#__PURE__*/function (_Component) {
  _inherits(SwipableArea, _Component);

  var _super = _createSuper(SwipableArea);

  function SwipableArea(props) {
    var _this;

    _classCallCheck(this, SwipableArea);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var id = _this.props.id;
      _this.element = document.getElementById(id);

      if (id && _this.element) {
        _this.element.addEventListener('touchstart', function (evt) {
          return _this.setUpTouchStart(evt);
        }, false);

        _this.element.addEventListener('touchmove', function (evt) {
          return _this.handleTouchMove(evt);
        }, false);

        _this.element.addEventListener('touchend', _this.reset(0, 0), false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setUpTouchStart", function (evt) {
      _this.lastX = evt.touches[0].clientX;
      _this.lastY = evt.touches[0].clientY;
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      var id = _this.props.id;
      _this.element = document.getElementById(id);

      if (id && _this.element) {
        _this.element.removeEventListener('touchstart', _this.setUpTouchStart);

        _this.element.addEventListener('touchmove', _this.handleTouchMove);

        _this.element.addEventListener('touchend', _this.reset);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function (x, y) {
      _this.lastX = x;
      _this.lastY = y;
    });

    _defineProperty(_assertThisInitialized(_this), "handleTouchMove", function (evt) {
      var _this$props = _this.props,
          minimunSpace = _this$props.minimunSpace,
          onSwipeRight = _this$props.onSwipeRight,
          onSwipeLeft = _this$props.onSwipeLeft,
          onSwipeUp = _this$props.onSwipeUp,
          onSwipeDown = _this$props.onSwipeDown;
      var x = evt.touches[0].clientX;
      var y = evt.touches[0].clientY;
      var xDiff = Math.abs(_this.lastX - x);
      var yDiff = Math.abs(_this.lastY - y);
      var xWay = _this.lastX - x > 0 ? 'right' : 'left';
      var yWay = _this.lastX - y > 0 ? 'down' : 'up';

      if (onSwipeRight && xWay === 'right' && xDiff > minimunSpace) {
        onSwipeRight();

        _this.reset(x, y);
      }

      if (onSwipeLeft && xWay === 'left' && xDiff > minimunSpace) {
        onSwipeLeft();

        _this.reset(x, y);
      }

      if (onSwipeDown && yWay === 'down' && yDiff > minimunSpace) {
        onSwipeDown();

        _this.reset(x, y);
      }

      if (onSwipeUp && yWay === 'up' && yDiff > minimunSpace) {
        onSwipeUp();

        _this.reset(x, y);
      }
    });

    _this.lastX = 0;
    _this.lastY = 0;
    return _this;
  }

  _createClass(SwipableArea, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          id = _this$props2.id;

      if (!id) {
        (0, _gerenciatdUtils.errorLog)('[SwipableArea]: must have id');
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        id: id,
        children: children
      });
    }
  }]);

  return SwipableArea;
}(_react.Component);

SwipableArea.propTypes = {
  /**
   * {
   *  "info": "Define el identificador del componente",
   *  "kind": "both",
   *  "beautifulName": "Identificador"
   * }
   */
  id: _propTypes["default"].string.isRequired,

  /**
   * {
   *  "info": "Recorrido mínimo con el dedo para que se produzca un swipe",
   *  "kind": "playground",
   *  "beautifulName": "Mínimo Swipe"
   * }
   */
  minimunSpace: _propTypes["default"].number,

  /**
   * {
   *  "info": "Función js que se ejecutará al hacer swipeRight, si es necesario",
   *  "kind": "playground",
   *  "beautifulName": "Función Right"
   * }
   */
  onSwipeRight: _propTypes["default"].func,

  /**
  * {
  *  "info": "Función js que se ejecutará al hacer swipeLeft, si es necesario",
  *  "kind": "playground",
  *  "beautifulName": "Función Left"
  * }
  */
  onSwipeLeft: _propTypes["default"].func,

  /**
  * {
  *  "info": "Función js que se ejecutará al hacer swipeUp, si es necesario",
  *  "kind": "playground",
  *  "beautifulName": "Función Up"
  * }
  */
  onSwipeUp: _propTypes["default"].func,

  /**
  * {
  *  "info": "Función js que se ejecutará al hacer swipeDown, si es necesario",
  *  "kind": "playground",
  *  "beautifulName": "Función Down"
  * }
  */
  onSwipeDown: _propTypes["default"].func
};
SwipableArea.defaultProps = {
  minimunSpace: 80,
  onSwipeRight: null,
  onSwipeLeft: null,
  onSwipeUp: null,
  onSwipeDown: null
};
var _default = SwipableArea;
exports["default"] = _default;

//# sourceMappingURL=index.js.map